import './auth/startSessionPrewarm';
import './index.css';
import './i18n';
import '@gokrew/ui/i18n';
import App from './App.tsx';
import { StrictMode } from 'react';
import { bootstrap, setupFilePreview, UserbackProvider } from '@gokrew/ui';
import { DialogProvider, AppConfigProvider } from '@gokrew/ui/context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '@sentry/react';
import { EmployeePortalAuthProvider } from './context/EmployeeAuthContext.tsx';
import { Toaster } from 'react-hot-toast';
import { PermissionsProvider } from '@/context/PermissionContext.tsx';
import { TimesheetPolicyProvider } from '@/context/TimesheetPolicyContext.tsx';
import { preloadCurrentRoute } from '@/utility/routePreloader';

setupFilePreview(
  new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
    },
  },
});

const app = (
  <StrictMode>
    <ErrorBoundary fallback={<p>Something went wrong</p>}>
      <QueryClientProvider client={queryClient}>
        <AppConfigProvider>
          <UserbackProvider>
            <EmployeePortalAuthProvider>
              <PermissionsProvider>
                <TimesheetPolicyProvider>
                  <DialogProvider>
                    <Toaster position="top-right" reverseOrder={false} />
                    <App />
                  </DialogProvider>
                </TimesheetPolicyProvider>
              </PermissionsProvider>
            </EmployeePortalAuthProvider>
          </UserbackProvider>
        </AppConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);

preloadCurrentRoute();
bootstrap('root', app);
